import { IHabitTrackerCalendarDay } from '../habit-tracker-interfaces';

interface IDayViewProps {
    day: IHabitTrackerCalendarDay;
    todo_id: number|string;
}

const DayView = ({ day }: IDayViewProps) => {

    return (
        <div
             className={ `bg-slate-50 p-1 ${ day.isTodayDay ? 'border border-slate-500' : '' }` }>
            <div className="mb-1 text-right text-xs">{ day.dayName }</div>
            <div className={ `text-center text-sm text-black` }>

                {
                    day.isChecked &&
                    <span>✅</span>
                }

                {
                    !day.isChecked &&
                    <span>&nbsp;</span>
                }

                {/*{
                    day.isChecked &&
                    <button
                        title="Remove Log"
                        onClick={ removeLogHandler }
                        type="button">
                        ✅
                    </button>
                }

                {
                    !day.isChecked &&
                    <button
                        title="Add Log"
                        className="w-full"
                        onClick={ addLogHandler }
                        type="button">
                        &nbsp;
                    </button>
                }*/}
            </div>
        </div>

    );
}

export default DayView;